import React from 'react';
import { cx } from '../../styles';

export type IconProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
};

// Size mappings for consistent icon dimensions
const sizeMap = {
  xs: 'h-3.5 w-3.5',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

// Base SVG props for all icons
const baseSvgProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none',
  viewBox: '0 0 24 24',
  stroke: 'currentColor',
  strokeWidth: 2,
};

export const SearchIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

export const SendIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
    />
  </svg>
);

export const PlusIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4v16m8-8H4"
    />
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const MenuIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 6h16M4 12h16M4 18h16"
    />
  </svg>
);

export const ChatIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
    />
  </svg>
);

// Added new icons for the sidebar
export const HomeIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 12l2-2m0 0l7-7 7 7m-7-7v14"
    />
  </svg>
);

export const DiscoverIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

export const CollectionsIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
  </svg>
);

export const LibraryIcon: React.FC<IconProps> = ({ size = 'sm', className }) => (
  <svg 
    {...baseSvgProps} 
    className={cx(sizeMap[size], className)}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
    />
  </svg>
);
